import React from 'react';
import { withFormik, Form } from 'formik';
import styled from 'styled-components';
import * as yup from 'yup';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '../../../components/atomic/Buttons/Button';
import FileUploader from '../../../components/atomic/Inputs/FileUploader';
import ModalSelect from '../../../components/molecule/FormFields/ModalSelect';
import MultiTextInput from '../../../components/molecule/FormFields/MultiTextInput';
import VideoSelect from '../../../components/molecule/FormFields/VideoSelect';
import TextInput from '../../../components/molecule/FormFields/TextInput';
import { AlertModal } from '../../../components/molecule/Modals/AlertModal';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import * as apiServices from '../../../services/apiServices';
import Icon from '@material-ui/core/Icon';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { startPolling } from '../../../modules/UploadQueue';
import { toast } from 'react-toastify';
import { createSelect } from '../../../utils';
import tooltips from '../../../core/tooltips';
import {
  ACCEPTED_VIDEO_FORMATS,
  LIMITS,
  STREAMING_STATUS,
} from '../../../core/constants';

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: auto;
  max-width: 800px;
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  color: #666;
  cursor: pointer; 
  span {
    cursor: pointer; 
  }
`
const CheckboxStyled = styled(Checkbox)`
  padding: 6px;
`
const StretchContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 30px 10px;
  justify-content: center;
`
const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: 200px;
  justify-content: center;
  align-items: center;
  ${'' /* height: 100%; */}
  // background: rgba(0,0,0,0.1);
  ${'' /* flex-shrink: 1; */}
  margin-right: 10px;
  margin-top: 10px;
  overflow: hidden;
`

const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  justify-content: center;
  align-items: center;
  ${'' /* height: 100%; */}
  // background: rgba(0,0,0,0.1);
  ${'' /* flex-shrink: 1; */}
  margin-right: 10px;
  margin-top: 10px;
  overflow: hidden;
`

const UploadProgressContainer = styled.div`
  margin-top: 8px;
  width: 100%;
`

const Aside = styled.div`
  display: flex;
  flex-direction: column;
`

const Image = styled.img`
  max-width: 10%;
  max-height: 10%;
  transform: scale(10);
`

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 160px;
`

const PlaceholderIconStyled = styled(Icon)`
  font-size: 40px;
  margin-bottom: 8px;
`

const InputStyled = styled(Input)`
  border: 1px solid #ccc;
  background: #eee;
  padding: 10px;
  margin-bottom: 6px;
  border-radius: 10px;
`

const TextInputStyled = styled(TextInput)`
  border: 1px solid #ccc;
  background: #eee;
  padding: 10px;
  margin-bottom: 6px;
  border-radius: 10px;
`

const ModalSelectStyled = styled(ModalSelect)`
  margin-bottom: 8px;
`
const IconStyled = styled(Icon)`
  color: white;
`

const DropContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  justify-content: flex-end;
  height: 1px;
  z-index: 1;
`

const RemoveIconStyled = styled(Button)`
  position: absolute;
  padding: 0;
  right: 0;
  min-width: 40px;
  max-width: 40px;
  height: 40px;
`

const MultiTextInputStyled = styled(MultiTextInput)`
  margin-bottom: 8px;
`

const InfoContainer = styled(Paper)`
  display: flex;
  flex-direction: column;
  ${'' /* margin: 3px; */}
  margin-top: 10px;
  padding: 10px 15px;
  margin-bottom: auto;
`
const HeaderContainer = styled.div`
  // background: rgba(0,0,0,0.1);
  margin: 10px 0;
`
const FormStyled = styled(Form)`
  display: flex;
`
const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 160px;
`
const Header = styled.div`
  // background: rgba(0,0,0,0.1);
  margin: 3px;
  font-size: 20px;
  font-weight: 600;
`
const SubHeader = styled.div`
  // background: rgba(0,0,0,0.1);
  margin: 3px;
  font-size: 12px;
`
const OptionSelect = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
`
const UploadButtonContainer = styled.div`
  width: 100%;
`
const VideoSelectStyled = styled(VideoSelect)`
  display: flex;
  width: 100%;
`

class ClassesDetailForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      imageUploadProgress: 0,
      submitted: false,
      videoUploadProgress: 0,
    }
  }

  componentDidUpdate(prevProps) {
    const { classOverviewVideos: prevClassOverviewVideos } = prevProps.uploadQueueState;
    const { uploadQueueState: { classOverviewVideos }, values } = this.props;

    if (prevClassOverviewVideos && classOverviewVideos &&
        prevClassOverviewVideos[values.id] && classOverviewVideos[values.id] &&
        prevClassOverviewVideos[values.id].streaming_status === STREAMING_STATUS.PROCESSING &&
        classOverviewVideos[values.id].streaming_status === STREAMING_STATUS.COMPLETE) {

      this.changeTracker({
        id: classOverviewVideos[values.id].videoId,
        source_video: classOverviewVideos[values.id].video,
        streaming_status: classOverviewVideos[values.id].streaming_status,
        thumbnail: classOverviewVideos[values.id].thumbnail,
        video: classOverviewVideos[values.id].streaming_video,
      }, 'video');
    }
  }

  changeTracker = (value, name) => this.props.setFieldValue(name, value, true);
  removeVideo = () => this.changeTracker(null,'video')
  removeImage = () => this.changeTracker(null,'image')

  imageUploadFinished = ({ awsUrl }) => {
    apiServices.addOverviewImage({ url: awsUrl })
      .then(data => {
        toast.success('image uploaded successfully');
        this.changeTracker({id: data.id, url: data.url}, 'image');
        this.setState({ imageUploadProgress: 0 });
      });
  }
  updateImageUploadProgress = (imageUploadProgress) => {
    this.setState({ imageUploadProgress });
  }

  videoUploadFinished = ({ awsUrl }) => {
    const { startPolling, values } = this.props;

    apiServices.addOverviewVideo({
      streaming_status: STREAMING_STATUS.PROCESSING,
      subtitle: '',
      video: awsUrl,
    }).then(data => {
      toast.success('video uploaded successfully');
      this.setState({ videoUploadProgress: 0 });
      startPolling({
        id: values.id,
        videoId: data.id,
        streaming_status: STREAMING_STATUS.PROCESSING,
        uploadType: 'classOverviewVideos'
      });
    });
  }
  updateVideoUploadProgress = (videoUploadProgress) => {
    this.setState({ videoUploadProgress });
  }

  render () {
    const {
      authState: { userData },
      options,
      uploadQueueState: { classOverviewVideos },
      values,
    } = this.props
    const {
      imageUploadProgress,
      videoUploadProgress,
    } = this.state;
    const categorySelect = createSelect('Choose Categories', 'Choose Categories', 'category', options.categories.map(item => ({ label: item.name, value: item.name })), true);
    const categoryValue = values.categories.map(item => ({ label: item, value: item }));

    const musclegroupSelect = createSelect('Choose Muscle Groups', 'Choose Muscle Groups', 'musclegroup', options.musclegroups.map(item => ({ label: item.name, value: item.id })), true);
    const musclegroupValue = values.musclegroup.map(item => ({ label: item.name, value: item.id }));

    const intensitylevelSelect = createSelect('Choose Intensity Level', 'Choose Intensity Level', 'intensity_level', options.intensity_level.map(item => ({ label: item.name, value: item.level })), false);
    const intensitylevelIndex = values.intensity_level ? options.intensity_level.findIndex(item => item.level === values.intensity_level) : -1;
    const intensitylevelValue = intensitylevelIndex > -1 ? [{ label: options.intensity_level[intensitylevelIndex].name, value: options.intensity_level[intensitylevelIndex].level }] : [];
    return (
      <FormStyled>
        <Container>
          <StretchContainer>
            <Aside>
              <ImageContainer>
                <UploadButtonContainer>
                  <FileUploader
                    accept='image/*'
                    buttonText="Upload Image"
                    fileType="image"
                    fullWidth
                    onFinish={this.imageUploadFinished}
                    onProgress={this.updateImageUploadProgress}
                    variant='contained'
                  />
                </UploadButtonContainer>
                {
                      values.image ? (
                        <React.Fragment>
                          <DropContainer>
                            <RemoveIconStyled variant='contained' color="secondary" onClick={() => AlertModal('Delete Image','Are you sure you want to delete this image?', this.removeImage)}>
                              <IconStyled>delete_forever</IconStyled>
                            </RemoveIconStyled>
                          </DropContainer>
                          <ImageWrapper>
                            <Image src={values.image.url} alt='class picture'/>
                          </ImageWrapper>
                        </React.Fragment>
                      ) : (
                        <ImageWrapper style={{opacity: 0.3}}>
                          <PlaceholderIconStyled>photo</PlaceholderIconStyled>
                          No Image
                        </ImageWrapper>
                      )
                    }
                { imageUploadProgress > 0 && (
                  <UploadProgressContainer>
                    <LinearProgress variant="determinate" value={imageUploadProgress} />
                  </UploadProgressContainer>
                )}
              </ImageContainer>
              <VideoContainer>
                <UploadButtonContainer>
                  <FileUploader
                    accept={ACCEPTED_VIDEO_FORMATS}
                    buttonText="Upload Video"
                    fileType="video"
                    fullWidth
                    metadata={{ trainer_id: userData.user_id.toString() }}
                    onFinish={this.videoUploadFinished}
                    onProgress={this.updateVideoUploadProgress}
                    variant='contained'
                  />
                </UploadButtonContainer>
                <OptionWrapper>
                  <OptionSelect>
                    {
                      values.video ? (
                        <VideoSelectStyled
                          onDelete={() => AlertModal('Delete Video','Are you sure you want to delete this video?', this.removeVideo)}
                          processing={(classOverviewVideos[values.id] && classOverviewVideos[values.id].streaming_status === STREAMING_STATUS.PROCESSING)}
                          thumbnail={values.video.thumbnail}
                          video={values.video.video}
                        />
                      ) : (
                        <ImageWrapper style={{opacity: 0.3}}>
                          <PlaceholderIconStyled>photo</PlaceholderIconStyled>
                          No Video
                          {
                            classOverviewVideos[values.id] && classOverviewVideos[values.id].streaming_status === STREAMING_STATUS.PROCESSING &&
                              <CircularProgress />
                          }
                        </ImageWrapper>
                      )
                    }
                  </OptionSelect>
                </OptionWrapper>
                { videoUploadProgress > 0 && (
                  <UploadProgressContainer>
                    <LinearProgress variant="determinate" value={videoUploadProgress} />
                  </UploadProgressContainer>
                )}
              </VideoContainer>
            </Aside>
            <InfoContainer>
              <HeaderContainer>
                <Header>Class Title</Header>
              </HeaderContainer>
              <InputStyled
                type="text"
                fullWidth
                disableUnderline
                onChange={(e) => this.changeTracker(e.target.value,'title')}
                value={values.title}
                inputProps={{ maxLength: LIMITS.classes.title }}
              />
              <HeaderContainer>
                <Header>Overview</Header>
                <SubHeader>Write a description of your class</SubHeader>
              </HeaderContainer>
              <TextInputStyled
                type="text"
                placeholder="Enter class description..."
                onChange={(val) => this.changeTracker(val,'description')}
                value={values.description}
                maxLength={LIMITS.classes.overview}
              />
              <HeaderContainer>
                <Header>More Details</Header>
                <SubHeader>This exercise needs more details to help members understand the correct form. This will also help you plan future classes.</SubHeader>
              </HeaderContainer>
              {/* <ChipSelect
                header="Equipment"
                type="text"
                onChange={(val) => this.changeTracker(val,'equipment')}
                value={values.equipment}
                options={options.equipment.map(item => item.name)}
              /> */}
              <ModalSelectStyled
                text={categorySelect.buttonText}
                multiple={true}
                header="Categories"
                value={categoryValue}
                options={categorySelect.value}
                onChange={(val) => this.changeTracker(val, 'categories')}
                variant='outlined'
                limit={LIMITS.classes.categories}
              />
              <ModalSelectStyled
                text={musclegroupSelect.buttonText}
                multiple={true}
                header="Muscle Groups"
                value={musclegroupValue}
                options={musclegroupSelect.value}
                onChange={(val) => this.changeTracker(val, 'musclegroup')}
                variant='outlined'
                limit={LIMITS.classes.musclegroups}
              />
              <MultiTextInputStyled
                header="Tags"
                type="text"
                onChange={(val) => this.changeTracker(val,'tags')}
                value={values.tags}
                options={[]}
                tooltipTitle={tooltips.class.tags.title}
                limit={LIMITS.classes.tags}
              />
              <ModalSelectStyled
                text={intensitylevelSelect.buttonText}
                multiple={false}
                header="Intensity Level"
                value={intensitylevelValue}
                options={intensitylevelSelect.value}
                onChange={(val) => this.changeTracker(val, 'intensity_level')}
                variant='outlined'
              />
              {
                (userData?.is_staff || userData?.is_superuser)
                  ? (<Wrapper onChange={() => this.changeTracker(!values.premium_required, 'premium_required')}>
                    <CheckboxStyled checked={values.premium_required} />
                    <span style={{
                      'cursor': 'pointer'
                    }}>Premium</span>
                  </Wrapper>)
                  : null
              }
            </InfoContainer>
          </StretchContainer>
        </Container>
      </FormStyled>
    );
  }
};

function mapStateToProps(state) {
  return {
    authState: state.authState,
    uploadQueueState: state.uploadQueueState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    startPolling: startPolling,
  }, dispatch)
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withFormik({
  mapPropsToValues: props => Object.assign(props.initialValues),

  validationSchema: yup.object().shape({
    name: yup.string(),
    last: yup.string(),
  }),

  validate: (values, props) => {
    props.submit(values);
  },

  displayName: 'ClassesDetailForm',
}))(ClassesDetailForm);
